<template>
  <div class="order-index-vue-scoped-css">
    <el-container class="root_container">
      <el-header style="height: 36px;overflow: hidden;">
        <vHead></vHead>
      </el-header>
      <keep-alive>
        <el-header style="height: 100px"><vNav></vNav></el-header>
      </keep-alive>
      <div
        class=""
        style="
            display: flex;
            width: 1190px;
            margin: 0 auto;
            justify-content: space-between;
            padding-top: 33px;
            padding-bottom: 20px;
          "
      >
        <div>
          <span
            style="
                height: 40px;
                font-size: 24px;
                margin-top: 5px;
                font-family: MicrosoftYaHei;
                color: #262626;
                line-height: 40px;
              "
            >成功提交订单</span
          >
        </div>
        <vProcess :step="step" :titleArr="titleArr"></vProcess>
      </div>
      <!-- <el-main style="min-width:1200px">
        <vSearch></vSearch>
        <vProcess :step="step" :titleArr="titleArr"></vProcess>
      </el-main> -->
      <div style="width: 1200px; margin: 0px auto;">
        <vCard>
          <!-- <div slot="title" class="card-head" style="height: 50px">
            <div class="card-title" style="float: left;font-size: 16px;font-weight: bold">成功提交订单</div>
          </div> -->
          <!-- <div class="rect theme-bg"></div> -->
          <div style="padding:0px 145px;">
            <div class="" style="padding-top:40px;">
              <img src="/static/img/sucess.png" style="width:44px;" />
            </div>
            <div class="tips " v-if="order.source == 2">
              <!-- <span class="el-icon-circle-check theme-col"></span> -->
              兑换成功，系统将尽快为您充值！
            </div>
            <div class="tips " v-if="order.source != 2 && order.source != 3">
              <!-- <span class="el-icon-circle-check theme-col"></span> -->
              兑换成功，我们将第一时间为您发货！
            </div>
            <div class="tips " v-if="order.source == 3">
              <!-- <span class="el-icon-circle-check theme-col"></span> -->
              兑换成功，我们将尽快为您发送兑换码！
            </div>
            <div style="color:#7a7a7a  ;font-size:13px  ;">
              <div
                class="order-no"
                style="color:#7a7a7a  ;font-size:13px  ;margin-top: 10px;line-height: 28px;"
              >
                订单编号：{{ order.ordersn }}
              </div>
              <div
                class="order-no"
                style="color:#7a7a7a  ;font-size:13px  ;margin-top: 10px;line-height: 28px;"
              >
                商品名称：{{ order.goodsname }}
              </div>
              <div class="" v-if="order.source == 2">
                <div
                  class="order-time"
                  style="color:#7a7a7a  ;font-size:13px  ;line-height: 28px;"
                  v-for="(item, index) in order.exp_param"
                  :key="index"
                >
                  {{ item.title }}： {{ item.value }}
                </div>
              </div>
              <div
                class="order-time"
                style="color:#7a7a7a  ;font-size:13px  ;line-height: 28px;"
              >
                下单时间：{{ times(order.time) }}
              </div>
              <div
                class="order-time"
                style="color:#7a7a7a  ;font-size:13px  ;line-height: 28px;"
                v-if="order.source == 2"
              >
                通知号码：{{ order.mobile }}
              </div>
              <div
                class="order-time"
                style="color:#7a7a7a  ;font-size:13px  ;line-height: 28px;"
                v-if="order.source == 3"
              >
                收货人手机：{{ order.mobile }}
              </div>
              <div
                class="order-price"
                style="color:#7a7a7a  ;font-size:13px  ;line-height: 28px;"
              >
                订单总价：
                <span v-if="order.totalpoint">
                  <span style="color:#E23130">{{ order.totalpoint }}</span>
                  {{ $store.state.name }}
                </span>
                <span v-if="order.total_cash">
                  <span style="color:#E23130" v-if="order.totalpoint">+</span>
                  <span style="color:#E23130">{{ order.total_cash }}</span>元
                </span>
              </div>
              <div
                class="remarks"
                style="color:#7a7a7a  ;font-size:13px  ;line-height: 28px;"
                v-if="
                  order.remark != 'undefined' &&
                    order.source != 3 &&
                    order.source != 2
                "
              >
                备注：{{ order.remark }}
              </div>
            </div>
            <router-link :to="{ name: 'Myorder' }">
              <div class="view-order theme-bg">查看订单</div>
            </router-link>
            <div style="height:36px"></div>
          </div>
        </vCard>
      </div>
    </el-container>
    <el-footer
      style=" background: #ffffff;height:auto;padding:0;border-top:solid 1px #e5e5e5;"
    >
      <vFooter></vFooter>
    </el-footer>
  </div>
</template>

<script>
import vHead from "@/common/header";
import vSearch from "@/common/search";
import vProcess from "@/common/process";
import vCard from "@/common/card";
import vNav from "@/common/nav";
export default {
  name: "",
  data() {
    return {
      step: 3,
      titleArr: ["选择商品", "确认订单", "成功提交订单"],
      order: ""
    };
  },
  components: {
    vHead,
    vSearch,
    vProcess,
    vCard,
    vNav
  },
  methods: {
    getorder() {
      this.$api.get(
        "order/orders/payinfo",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          ordersn: this.$route.params.ordersn
        },
        res => {
          if (res.data.code == 100) {
            this.order = res.data.data;
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    times: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m;
      if (date.getMinutes() < 10) {
        m = "0" + date.getMinutes() + ":";
      } else {
        m = date.getMinutes() + ":";
      }
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    }
  },
  created() {
    this.getorder();
  }
};
</script>

<style lang="less" scoped>
.card-title {
  padding: 14px;
}
.rect {
  width: 36px;
  height: 6px;
  border-radius: 3px;
  margin: 13px auto 0px auto;
}
.el-icon-circle-check {
  font-size: 30px;
}
.tips {
  height: 40px;
  font-size: 24px !important;
  font-family: MicrosoftYaHei;
  color: #262626;
  line-height: 40px;
  margin-top: 14px;
  border-bottom: solid 1px #f5f5f5;
  padding-bottom: 8px;
}
.view-order {
  width: 168px;
  height: 40px;
  margin: 25px auto 0px auto;
  line-height: 40px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/affirmOrder/ordersucceed.vue